/**
 * Comparator card copy for Order In Progress "Sequencing Options".
 * Aligns with OrderStart.tsx (family sample count + biological parent labels).
 */
export function orderInProgressComparatorSequencingCopy(
  parentSamplesRequired: number,
  orderType: string | undefined
): { title: string; description: string } {
  const n = Math.max(1, parentSamplesRequired)
  const title = `Include ${n} family sample${n !== 1 ? 's' : ''} for comparison`
  let description: string
  if (parentSamplesRequired >= 2) {
    description = 'Biological Mother + Biological Father'
  } else if (orderType === 'FAMILY_DUO_MOTHER') {
    description = 'Biological Mother'
  } else if (orderType === 'FAMILY_DUO_FATHER') {
    description = 'Biological Father'
  } else {
    description = 'Biological parent'
  }
  return { title, description }
}
